import { formatQuantity } from '../shared/pipes/format-quantity.pipe';

export class PeerToPeerModel {
    _id!: string;
    userName!: string;
    userID!: string;
    medDescription!: string;
    indexID!: number;
    device!: string;
    locationGrouping!: string;
    locationGrouping2!: number;
    adminGrouping!: string;
    adminGrouping2!: number;
    transactionType!: string;
    numMedRmvlsUser4AllPts!: number;
    numMedRmvlsAllUser4AllPts!: number;
    numPtsCareByUsers!: number;
    numPtsCaredByAllUsers!: number;
    userRemovalsPts!: number;
    allUsersRemovalsPtsMean!: number;
    stdDevUserPts!: number;
    stdDevMean!: string;
    serviceGroup!: string;
    medGroupName!: string;
    image!: string;

    static fromJson(json: any) {
        let model = new PeerToPeerModel();
        model = Object.assign(model, json, {
            userRemovalsPts: formatQuantity(json.userRemovalsPts)
            , allUsersRemovalsPtsMean: formatQuantity(json.allUsersRemovalsPtsMean)
            , stdDevUserPts: formatQuantity(json.stdDevUserPts)
            , stdDevMean: formatQuantity(json.stdDevMean)
            , transactionType: getTransactionType(json.transactionType)
            , adminFlagCount: formatQuantity(json.adminFlagCount)
        });
        if(!["",null, undefined].includes(json.medGroupName))
        model.medGroupName = json.medGroupName;
        else
        model.medGroupName = json.medDesc;
        return model;
    }




    public toJson() {
        return Object.assign({}, this, {
            _id: this._id
        });
    }
}

function getTransactionType(transactionType: any) {
    if ((transactionType == "Integrated waste") || (transactionType == "Waste")) {
        return "Waste";
    }
    else if (transactionType == "Override") {
        return "Override"
    }
    else if (transactionType == "Removal")
    {
        return "Removal"
    }
    else if (transactionType == "Med Use")
    {
        return "Med Use"
    }
    else if (transactionType == "Cancel")
    {
        return "Cancel"
    }
    else if (transactionType == "Return")
    {
        return "Return"
    }
    else if (transactionType == "Full Waste")
    {
        return "Full Waste"
    }
    return transactionType;
}